import $ from 'jquery';
import hub from '../utility/events-hub';

// const lang = document.documentElement.getAttribute('lang');

let isInitialized = false;
let options;

let $modal;
let $wrapper;
let $error;
let $content;
let $typeSelector;
let $radioType;
let $radioTypePallet;
let $radioTypeColli;
let $counter;
let $stock;
let $submit;
let $packagesAmountLabel;
let $packageTypeLabel;
let $itemsPerPackageLabel;
let $itemsTotalLabel;
let $pricePerItemLabel;
let $pricePerPackageLabel;
let $priceTotalLabel;
let $priceTotalExVatLabel;
let $itemsLabel;

let $productQuantityInput;
let $productAddButton;

let variantCode;
let itemsLabel;

const defaultLabels = {
    batchType: 0,
    packagesAmount: 1,
    itemsPerPackage: 1,
    itemsTotal: 1,
    pricePerItem: '',
    pricePerPackage: '',
    priceTotal: '',
    priceTotalExlVat: '',
    hasError: false,
    errorMessage: null
};

const initCounter = function(el) {

    const $counterWrapper = $(el);

    const $input = $('.js-package-amount-input', $counterWrapper);
    const $decreas = $('.js-package-amount-decrease', $counterWrapper);
    const $increas = $('.js-package-amount-increase', $counterWrapper);

    let value;
    let delta;
    let min;
    let max;

    const getValue = () => {
        return parseInt($input.val(), 10);
    };

    const getConstraints = () => {
        value = getValue();
        delta = parseInt($input.data('delta'), 10);
        min = parseInt($input.attr('min'), 10);
        max = parseInt($input.attr('max'), 10);
    };

    const sanitizeValue = (newValue) => {
        const intValue = parseInt(newValue, 10);
        if (isNaN(intValue)) {
            return value;
        }
        if (intValue < min) {
            return min;
        }
        if (intValue > max) {
            return max;
        }
        return intValue;
    };

    const updateValue = (newValue) => {
        const sanitizedValue = sanitizeValue(newValue);
        if (sanitizedValue !== newValue || sanitizedValue !== value) {
            value = sanitizedValue;
            $input.val(sanitizedValue);
            $input.trigger('change');
        }
    };

    const increase = (increaseDelta) => {
        const newValue = getValue() + increaseDelta;
        updateValue(newValue);
    };

    const reset = () => {
        $input.val(min);
    };

    $decreas.on('click', () => { increase(delta * (-1)); });
    $increas.on('click', () => { increase(delta); });
    $input.on('input', (e) => {
        updateValue(e.target.value);
        e.preventDefault();
    });
    $input.on('event.reset', reset);
    $input.on('event.refresh', getConstraints);

    getConstraints();

    return $input;
};

const errorMessageTmpl = (errorMessage) => {
    return `<p class="form-error">${errorMessage}</p>`;
};

/**
 * Updates calculator labels.
 * @function
 * @param {Object} labels - Labels data
 */
const updateLabels = (labels) => {
    if (labels.hasError) {
        $content.addClass('u-hidden');
        $error.html(errorMessageTmpl(labels.errorMessage));
        $error.removeClass('u-hidden');
        return;
    }

    $content.removeClass('u-hidden');
    $error.addClass('u-hidden');

    $itemsPerPackageLabel.text(labels.itemsPerPackage);
    $packagesAmountLabel.text(labels.packagesAmount);
    $packageTypeLabel.each((_, el) => {
        const $label = $(el);
        const isSinglePackageLabel = $label.data('package-single');
        const isCorrectTypeLabel = +$label.data('package-type') === labels.batchType;
        const isCorrectAmountLabel = isSinglePackageLabel === undefined || (isSinglePackageLabel === (labels.packagesAmount === 1));
        if (isCorrectTypeLabel && isCorrectAmountLabel) {
            $label.show();
        } else {
            $label.hide();
        }
    });
    $itemsTotalLabel.text(labels.itemsTotal);
    $pricePerItemLabel.text(labels.pricePerItem);
    $pricePerPackageLabel.text(labels.pricePerPackage);
    $priceTotalLabel.text(labels.priceTotal);
    $priceTotalExVatLabel.text(labels.priceTotalExlVat);
    $itemsLabel.text(labels.itemsLabel);
    const submitLabelTmpl =  $submit.data('label-tmpl');
    const submitLabel = submitLabelTmpl.replace('##QUANTITY##', `${labels.itemsTotal} ${labels.itemsLabel}`);
    $submit.text(submitLabel);
};

const getPrices = () => {

    const $selectedPackageType = $radioType.filter(':checked');
    const batchType = $selectedPackageType.val() === 'pallet' ? 0 : 1;
    const itemsPerPackage = $selectedPackageType.data('items');
    const quantity = +$counter.val();

    const data = {
        batchType,
        itemNumber: variantCode,
        quantity
    };

    $wrapper.addClass('loading');

    $.ajax({
        url: '/PalletColli/getprices',
        method: 'GET',
        data
    }).then((resp) => {
        const labelsData = {
            batchType,
            packagesAmount: quantity,
            itemsPerPackage,
            itemsTotal: resp.TotalQuantity,
            pricePerItem: resp.PricePerItem,
            pricePerPackage: resp.PricePerPackage,
            priceTotal: resp.TotalPrice,
            priceTotalExlVat: resp.TotalInclVat,
            itemsLabel,
            hasError: !resp.IsSuccess,
            errorMessage: resp.ErrorMessage
        };
        updateLabels(labelsData);
    }).always(() => {
        $wrapper.removeClass('loading');
    });
};

const calculatorSubmit = () => {
    hub.subscribeOnce(hub.event.addToCart, () => {
        $submit.removeClass('loading');
        $.fancybox.close();
    });

    $productQuantityInput.val($counter.val() * $radioType.filter(':checked').data('items'));
    $productAddButton.trigger('click');

    $submit.addClass('loading');
};

/**
 * Open package calculator.
 * @function
 * @param {Object} config - Calculator configuration
 * @param {number} config.code - Product code
 * @param {string} config.itemsLabel - Item label
 * @param {boolean} config.showPallet - Show pallet radio button as enabled
 * @param {boolean} config.showColli - Show colli radio button as enabled
 * @param {number} config.quantityPallet - Amount of item in one pallet
 * @param {number} config.quantityColli - Amount of item in one colli
 * @param {JQuery<HTMLElement>} config.$productQuantityInput - Product quantity input
 * @param {JQuery<HTMLElement>} config.$productAddButton - Product add to basket button
 */
const open = (config) => {
    if (!isInitialized || !config) return;

    const palletRadioEnabled = config.showPallet && config.quantityPallet;
    const colliRadioEnabled = config.showColli && config.quantityColli;

    if (!palletRadioEnabled && !colliRadioEnabled) return;

    $productAddButton = config.$productAddButton;
    $productQuantityInput = config.$productQuantityInput;

    variantCode = config.code;
    itemsLabel = config.itemsLabel;

    if (!palletRadioEnabled || !colliRadioEnabled) {
        $typeSelector.addClass('u-hidden');
    } else {
        $typeSelector.removeClass('u-hidden');
    }

    $radioTypePallet.prop('disabled', !palletRadioEnabled)
        .prop('checked', palletRadioEnabled)
        .data('items', config.quantityPallet);
    $radioTypeColli.prop('disabled', !colliRadioEnabled)
        .prop('checked', !palletRadioEnabled)
        .data('items', config.quantityColli);

    $stock.attr('data-variant-code', variantCode);
    window.app.stockLoader.refreshVariant(variantCode);

    $counter.val(1);

    updateLabels({
        ...defaultLabels,
        batchType: palletRadioEnabled ? 0 : 1,
        itemsPerPackage: palletRadioEnabled ? config.quantityPallet : config.quantityColli,
        itemsTotal: palletRadioEnabled ? config.quantityPallet : config.quantityColli,
        itemsLabel
    });

    $.fancybox.open({
        src: options.selectors.modal,
        opts: {
            touch: false,
            afterClose: function() {
                // $modal.find(options.selectors.colorPickerColorList).html('');
                // $modal.find(options.selectors.colorpickerBuyInner).html('');
                // $modal.removeClass('is-buying');
                // onResetSearch();
            }
        }
    });

    getPrices();
};

/**
 * Initialize pallet calculator on a page.
 * @function
 * @param {Object} [opts] - Calculator options
 * @param {Object} opts.selectors - Customize calculator element selectors
 */
const init = (opts) => {

    const defaults = {
        selectors: {
            modal: '#modal-calculator',
            wrapper: '.js-package-calculator-wrapper',
            calculatorContent: '.js-package-calculator-content',
            calculatorError: '.js-package-calculator-error',
            typeSelector: '.js-package-calculator-type-selector',
            radioType: '[name="PackageCalculatorType"]',
            radioTypePallet: '[name="PackageCalculatorType"][value="pallet"]',
            radioTypeColli: '[name="PackageCalculatorType"][value="colli"]',
            counter: '.js-package-amount-container',
            itemsPerPackageLabel: '.js-items-per-package-label',
            packagesAmountLabel: '.js-packages-amount-label',
            packageTypeLabel: '.js-package-type-label',
            itemsTotalLabel: '.js-items-total-label',
            pricePerItemLabel: '.js-price-per-item-label',
            pricePerPackageLabel: '.js-price-per-package-label',
            priceTotalLabel: '.js-price-total',
            priceTotalExVatLabel: '.js-price-total-ex-vat',
            stock: '.js-b2b-store-stock',
            submit: '.js-package-calculator-submit',
            itemsLabel: '.js-items-label'
        }
    };

    options = $.extend(true, defaults, opts);

    $modal = $(options.selectors.modal);
    $wrapper = $(options.selectors.wrapper, $modal);

    $content = $(options.selectors.calculatorContent, $modal);
    $error = $(options.selectors.calculatorError, $modal);

    $typeSelector = $(options.selectors.typeSelector, $modal);

    $radioType = $(options.selectors.radioType, $modal);
    $radioType.on('change', () => {
        $counter.trigger('event.reset');
        getPrices();
    });

    $radioTypePallet = $(options.selectors.radioTypePallet, $modal);
    $radioTypeColli = $(options.selectors.radioTypeColli, $modal);

    $counter = initCounter($(options.selectors.counter, $modal)[0]);
    $counter.on('change', () => {
        getPrices();
    });

    $stock = $(options.selectors.stock, $modal);

    $submit = $(options.selectors.submit, $modal);
    $submit.on('click', calculatorSubmit);

    $itemsPerPackageLabel = $(options.selectors.itemsPerPackageLabel, $modal);
    $packagesAmountLabel = $(options.selectors.packagesAmountLabel, $modal);
    $packageTypeLabel = $(options.selectors.packageTypeLabel, $modal);
    $itemsTotalLabel = $(options.selectors.itemsTotalLabel, $modal);
    $pricePerItemLabel = $(options.selectors.pricePerItemLabel, $modal);
    $pricePerPackageLabel = $(options.selectors.pricePerPackageLabel, $modal);
    $priceTotalLabel = $(options.selectors.priceTotalLabel, $modal);
    $priceTotalExVatLabel = $(options.selectors.priceTotalExVatLabel, $modal);
    $itemsLabel = $(options.selectors.itemsLabel, $modal);

    isInitialized = true;
};

export default {
    init,
    open
};
